import { render, staticRenderFns } from "./TestDragDrop.vue?vue&type=template&id=7fd396c5&scoped=true&"
import script from "./TestDragDrop.vue?vue&type=script&lang=js&"
export * from "./TestDragDrop.vue?vue&type=script&lang=js&"
import style0 from "./TestDragDrop.vue?vue&type=style&index=0&id=7fd396c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd396c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VContainer,VFlex,VLayout,VList,VListTile,VListTileContent,VListTileTitle})
